import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Col, Descriptions, Row, Skeleton, Typography } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getLstProductFamilyForProject, getProjectDetails } from '../../services/projectService';
import dayjs from 'dayjs';
import SubProjectDataTable from '../../components/projects/SubProjectDataTable';
import ProjectDetailServiceLevelStatus from '../../components/projects/ProjectDetailServiceLevelStatus';
import { getPrjEEMasterProducts } from '../../services/projectService';
import ProjectDetailMultiproductModal from '../../components/projects/ProjectDetailMultiproductModal';
import SubProjectProductFamilyModal from '../../components/projects/SubProjectProductFamilyModal';
import { useSelector } from 'react-redux';
import commonService from "../../services/CommonService";
import { UserActivity } from "../../config/BVConstants";
const ProjectDetails = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const [projectId, setProjectId] = useState();
    const { encodedProjectId } = useParams();
    const [projectDetail, setProjectDetail] = useState();
    const [isModalOpenMP, setIsModalOpenMP] = useState(false);
    const [lstMultiProduct, setLstMultiProduct] = useState([]);
    const [isModalOpenProductFamily, setIsModalOpenProductFamily] = useState(false);
    const [listOfProductFamily, setListOfProductFamily] = useState();
    const applicationData = useSelector((state) => state.applicationData); //useApplicationContext();
    const navigate = useNavigate();
    const boolScreenAccessCheck = ((_d = (_c = (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.getClientUserScreenAccess) === null || _a === void 0 ? void 0 : _a.lstClientUserCompanies) === null || _b === void 0 ? void 0 : _b.find((obj) => { var _a, _b; return obj.intId === ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID); })) === null || _c === void 0 ? void 0 : _c.lstObjLuScreens) === null || _d === void 0 ? void 0 : _d.find((obj) => obj.intId === 1)) != undefined;
    useEffect(() => {
        var _a, _b;
        if (encodedProjectId && boolScreenAccessCheck) {
            try {
                let decodedId = encodedProjectId ? atob(encodedProjectId) : null;
                if (decodedId) {
                    setProjectId(decodedId);
                    getProjectDetails(decodedId.toString()).then((responseData) => {
                        setProjectDetail(responseData);
                    });
                }
                commonService
                    .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__ProjectDetails_Visited);
            }
            catch (e) {
                navigate('/no-access');
            }
        }
        else {
            navigate('/no-access');
        }
    }, [encodedProjectId, boolScreenAccessCheck]);
    function handleOpenProductFamily(strProjectId) {
        setIsModalOpenProductFamily(true);
        getListOfProductFamily();
    }
    const formatDate = (date) => {
        const formattedDate = date == null || date == undefined
            ? null
            : dayjs(date, 'DD-MM-YYYY hh:mm:ss').format('DD-MMM-YYYY');
        return formattedDate;
    };
    function handleOpenMultiProdModal(projectId) {
        if (projectId) {
            setIsModalOpenMP(true);
            getLstMultiProduct(projectId);
        }
    }
    function handleOkMP() {
        setIsModalOpenMP(false);
    }
    function handleOkPF() {
        setIsModalOpenProductFamily(false);
    }
    function handleCancelMP() {
        setIsModalOpenMP(false);
    }
    function handleCancelPF() {
        setIsModalOpenProductFamily(false);
    }
    function getLstMultiProduct(projectId) {
        getPrjEEMasterProducts(projectId).then((responseData) => {
            setLstMultiProduct(responseData);
        });
    }
    function getListOfProductFamily() {
        getLstProductFamilyForProject(projectId).then((responseData) => {
            setListOfProductFamily(responseData);
        });
    }
    const items = [
        {
            key: '1',
            label: 'Entity Name',
            children: (_f = (_e = projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.objClientMaster) === null || _e === void 0 ? void 0 : _e.objLuCompany) === null || _f === void 0 ? void 0 : _f.strLongDesc
        },
        {
            key: '2',
            label: 'Project Status',
            children: ((_g = projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.objProjectStatus) === null || _g === void 0 ? void 0 : _g.intId) == 30001
                ? 'Not Started'
                : (_h = projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.objProjectStatus) === null || _h === void 0 ? void 0 : _h.strLongDesc
        },
        {
            key: '3',
            label: 'Risk Status',
            children: (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.riskStatusId) == 1 ? (_jsx("span", { children: "Project on Schedule" })) : (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.riskStatusId) == 2 ? (_jsx("span", { style: { color: '#ff0101' }, children: "Project on Risk" })) : ('')
        },
        {
            key: '4',
            label: 'Project Type',
            children: (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.intNewRenewalProjectType) == 1
                ? 'New'
                : (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.intNewRenewalProjectType) == 2
                    ? 'Renewal'
                    : ''
        },
        {
            key: '5',
            label: 'Product Name',
            children: (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.boolIsMultipleProdReq) ? (_jsx(Typography.Link, { onClick: (e) => handleOpenMultiProdModal(projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.strProjectId), children: "View Details" })) : (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.strProductNameEN)
        },
        {
            key: '6',
            label: 'Product Model',
            children: (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.boolIsMultipleProdReq) ? (_jsx(Typography.Link, { onClick: (e) => handleOpenMultiProdModal(projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.strProjectId), children: "View Details" })) : (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.strPrimaryModel)
        },
        {
            key: '7',
            label: 'Brand/OEM',
            children: !(projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.boolProductFamily) && !(projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.boolIsMultipleProdReq) ? ((_j = projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.objBrandName) === null || _j === void 0 ? void 0 : _j.strLongDesc) : (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.boolProductFamily) && !(projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.boolIsMultipleProdReq) ? (_jsx(Typography.Link, { onClick: (e) => handleOpenProductFamily(projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.strProjectId), children: (_k = projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.objBrandName) === null || _k === void 0 ? void 0 : _k.strLongDesc })) : (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.boolIsMultipleProdReq) ? (_jsx(Typography.Link, { onClick: (e) => handleOpenMultiProdModal(projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.strProjectId), children: "View Details" })) : ((_l = projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.objBrandName) === null || _l === void 0 ? void 0 : _l.strLongDesc)
        }
    ];
    if (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.dtReccomDecisionDate) {
        items.push({
            key: '8',
            label: 'Recommended Decision Date',
            children: formatDate(projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.dtReccomDecisionDate)
        });
    }
    if (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.dtDecisionDate) {
        items.push({
            key: '9',
            label: 'Actual Decision Date',
            children: formatDate(projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.dtDecisionDate)
        });
    }
    if (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.dtProjPlannedStartDate) {
        items.push({
            key: '10',
            label: 'Recommended Start Date',
            children: formatDate(projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.dtProjPlannedStartDate)
        });
    }
    if (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.dtActualStartDate) {
        items.push({
            key: '11',
            label: 'Actual Start Date',
            children: formatDate(projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.dtActualStartDate)
        });
    }
    if (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.dtClientDeadline) {
        items.push({
            key: '12',
            label: 'Client Deadline',
            children: formatDate(projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.dtClientDeadline)
        });
    }
    if (((_m = projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.objProjectStatus) === null || _m === void 0 ? void 0 : _m.intId) == 30004) {
        items.push({
            key: '13',
            label: 'Actual Completion Date',
            children: formatDate(projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.dtProjActCompetionDate)
        });
    }
    if (((_o = projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.objProjectStatus) === null || _o === void 0 ? void 0 : _o.intId) == 30005) {
        items.push({
            key: '14',
            label: 'Cancelled Date',
            children: formatDate(projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.dtProjCancelledDate)
        });
    }
    if ((_p = projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.objBusinessUnit) === null || _p === void 0 ? void 0 : _p.strBusinessUnitName) {
        items.push({
            key: '15',
            label: 'BV Location',
            children: (_q = projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.objBusinessUnit) === null || _q === void 0 ? void 0 : _q.strBusinessUnitName
        });
    }
    const loadingItems = [];
    const skeletonItem = {
        label: _jsx(Skeleton.Input, { active: true, size: 'default' }),
        children: _jsx(Skeleton.Input, { active: true, size: 'default' })
    };
    for (let i = 0; i < 8; i++) {
        loadingItems.push(skeletonItem);
    }
    return (_jsxs(Row, { gutter: [16, 16], children: [_jsx(SubProjectProductFamilyModal, { isModalOpen: isModalOpenProductFamily, handleOk: handleOkPF, handleCancel: handleCancelPF, modalContent: listOfProductFamily, title: 'Product Family Information' }), _jsx(ProjectDetailMultiproductModal, { isModalOpen: isModalOpenMP, handleOk: handleOkMP, handleCancel: handleCancelMP, modalContent: lstMultiProduct, title: 'Product Information' }), _jsx(Col, { xs: 24, sm: 24, md: 10, lg: 10, xl: 10, children: _jsx(Card, { style: { height: '100%', borderRadius: '0px' }, title: `PROJECT DETAIL (Project No: ${projectId})`, children: _jsx(Descriptions, { column: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 }, bordered: true, items: projectDetail ? items : loadingItems }) }) }), _jsx(Col, { xs: 24, sm: 24, md: 14, lg: 14, xl: 14, children: _jsx(ProjectDetailServiceLevelStatus, { projectId: projectId, objClientMaster: projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.objClientMaster, objMaster: projectDetail }) }), _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, children: _jsx(SubProjectDataTable, { lstWorkOrder: projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.lstWorkOrder, projectId: projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.strProjectId }) })] }));
};
export default ProjectDetails;
